import { Badge, Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import i18next from 'i18next';
import React, { useMemo } from 'react';
import { sluggify } from 'utils/localization/utils';
const VISIBLE_ITEMS_COUNT = 2;
export function HoverBadges({ value, doSluggify = true }) {
    const count = useMemo(() => { var _a; return ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) - VISIBLE_ITEMS_COUNT; }, [value]);
    const showCount = useMemo(() => {
        return count > 0;
    }, [count]);
    const visibleItems = useMemo(() => {
        if (count > 0) {
            return (value || []).slice(0, VISIBLE_ITEMS_COUNT);
        }
        return value || [];
    }, [count, value]);
    const hoverItems = useMemo(() => {
        if (count > 0) {
            return (value || []).slice(VISIBLE_ITEMS_COUNT);
        }
        return null;
    }, [count, value]);
    return (React.createElement("div", { className: "flex gap-2 py-2" },
        React.createElement("div", { className: "flex flex-wrap gap-2" }, visibleItems.map((item, i) => {
            return (React.createElement(Badge, { key: i }, doSluggify ? i18next.t(sluggify(item)) : item));
        })),
        showCount && (React.createElement("div", { className: "flex-1" },
            React.createElement(TooltipProvider, null,
                React.createElement(Tooltip, null,
                    React.createElement(TooltipTrigger, null,
                        React.createElement(Button, { variant: "icon", size: "icon", className: "underline text-blue-500 hover:text-blue-700" },
                            "+",
                            count)),
                    React.createElement(TooltipContent, { className: "max-w-sm" },
                        React.createElement("div", { className: "flex flex-wrap gap-2" }, (hoverItems !== null && hoverItems !== void 0 ? hoverItems : []).map((item, i) => {
                            return (React.createElement(Badge, { key: i }, doSluggify ? i18next.t(sluggify(item)) : item));
                        })))))))));
}
